/** @format */

import React from "react";
import { Button, Text } from "@chakra-ui/react";
import { usePersonalizacao } from "../../context/usePersonalizacao";

export function FiltrosItem({ onClick, isSelected, label }) {
  const {
    personalizacao: {
      filtros: { filtronaoselecionado, filtroselecionado },
    },
  } = usePersonalizacao();

  return (
    <Button
      paddingy="0.5rem"
      paddingx="1rem"
      borderWidth={!isSelected ? 1 : 0}
      borderColor={
        !isSelected
          ? filtronaoselecionado.bordercolor
          : filtroselecionado.bordercolor
      }
      background={
        !isSelected ? filtronaoselecionado.bgcolor : filtroselecionado.bgcolor
      }
      borderRadius="full"
      marginRight="0.5rem"
      marginY="0.5rem"
      _hover={{}}
      onClick={onClick}
      _focus={[{ borderWidth: 0 }]}>
      <Text
        fontSize="sm"
        color={
          !isSelected
            ? filtronaoselecionado.textcolor
            : filtroselecionado.textcolor
        }>
        {label}
      </Text>
    </Button>
  );
}
